import React from 'react';

export default function useForceUpdate() {
  const [, setState] = React.useState<number>(1);

  const forceUpdate = React.useCallback(() => {
    setState(Math.random());
  }, []);

  return forceUpdate;
}
